import type { FC } from 'react';
import { useStore } from 'zustand';

import { ArrowFullRightIcon, Button } from '@motorway/mw-highway-code';

import { ModalFooter } from 'Features/SellerCommunications/components/ModalFooter';
import { EnquiriesSelectStore, enquirySelectionService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import {
	triggerSellerMessagingCreateEmailButtonClickedEvent,
	triggerSellerMessagingMarkAsContactedButtonClickedEvent,
} from 'Services/analytics/events';

export const EnquirySelectionFooter: FC = () => {
	const selectedSalesCount = useStore(EnquiriesSelectStore, (state) => state.selectedSaleIds.length);

	const handleCreateEmailClick = () => {
		triggerSellerMessagingCreateEmailButtonClickedEvent(selectedSalesCount);
		enquirySelectionService.onCreateEmailClick();
	};

	const handleMarkAsContactedClick = () => {
		triggerSellerMessagingMarkAsContactedButtonClickedEvent(selectedSalesCount);
		enquirySelectionService.onMarkAsContactedClick();
	};

	return (
		<ModalFooter>
			<Button
				data-thc-button-footer
				disabled={!selectedSalesCount}
				label={T.translate(`enquiryList.markAsContacted_${selectedSalesCount ? 'some' : 'default'}`, {
					count: selectedSalesCount,
				})}
				onClick={handleMarkAsContactedClick}
				variant="secondary"
			/>
			<Button
				data-thc-button-footer
				disabled={!selectedSalesCount}
				icon={ArrowFullRightIcon}
				label={T.translate(`enquiryList.createEmail_${selectedSalesCount ? 'some' : 'default'}`, {
					count: selectedSalesCount,
				})}
				onClick={handleCreateEmailClick}
			/>
		</ModalFooter>
	);
};
